"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginPv = void 0;
var tslib_1 = require("tslib");
var basePlugin_1 = tslib_1.__importDefault(require("../base/basePlugin"));
var typings_1 = require("../typings");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var const_1 = require("../utils/const");
var util_1 = require("../utils/util");
var defaultOption = {
    disable: false,
    sampleRate: 100,
    spaMode: typings_1.SPAMODE.NODE,
};
var PluginPv = /** @class */ (function (_super) {
    tslib_1.__extends(PluginPv, _super);
    function PluginPv(queue, config) {
        if (config === void 0) { config = defaultOption; }
        var _this = _super.call(this, queue, config) || this;
        _this.name = PluginPv.id;
        _this.config = util_1.extend(defaultOption, config);
        _this.spaPV = _this.spaPV.bind(_this);
        return _this;
    }
    PluginPv.prototype.init = function () {
        var _this = this;
        this.reportPv();
        var spaMode = this.config.spaMode;
        if (spaMode === typings_1.SPAMODE.HASH) {
            window.addEventListener('hashchange', this.spaPV);
            return;
        }
        if (spaMode === typings_1.SPAMODE.HISTORY) {
            // 重写方法
            var _wr = function (type) {
                var origin = history[type];
                return function (data, title, url) {
                    var prevUrl = util_1.getPageUrl();
                    var prevPath = location === null || location === void 0 ? void 0 : location.pathname;
                    try {
                        var res = origin && origin.call(history, data, title, url);
                        if (!url ||
                            typeof url !== 'string' ||
                            prevUrl === util_1.getPageUrl() ||
                            prevPath === (location === null || location === void 0 ? void 0 : location.pathname))
                            return res;
                        _this.spaPV();
                        return res;
                    }
                    catch (error) {
                        logger_1.default.log('劫持 history api 失败', error);
                    }
                };
            };
            //重写方法
            history.pushState = _wr('pushState');
            history.replaceState = _wr('replaceState');
            return;
        }
    };
    PluginPv.prototype.spaPV = function () {
        this.queue.emit(const_1.SPA_PV);
        this.reportPv();
    };
    PluginPv.prototype.reportPv = function () {
        this.addData({
            type: const_1.METRICS_PV,
            value: 1,
            ts: Date.now(),
        });
    };
    PluginPv.id = typings_1.PLUGIN_NAME.PV;
    return PluginPv;
}(basePlugin_1.default));
exports.PluginPv = PluginPv;
//# sourceMappingURL=pv.js.map